import { render, staticRenderFns } from "./RichTextEditor.vue?vue&type=template&id=fd83faec&scoped=true"
import script from "./RichTextEditor.vue?vue&type=script&lang=js"
export * from "./RichTextEditor.vue?vue&type=script&lang=js"
import style0 from "./RichTextEditor.vue?vue&type=style&index=0&id=fd83faec&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd83faec",
  null
  
)

export default component.exports